import React from 'react';
import {
  LazyLoadComponent as ReactLazyLoadComponent, trackWindowScroll
} from 'react-lazy-load-image-component';

/* `createRef` was only introduced in React 16.2, so we need to polyfill it */
React.createRef = () => ({
  current: null
});

const DEFAULT_HEIGHT = "300px";
const DEFAULT_WIDTH = "100%";

const LazyLoadComponent = (props) => (
  <ReactLazyLoadComponent
    height={DEFAULT_HEIGHT}
    width={DEFAULT_WIDTH}
    {...props}
  />
);

export { LazyLoadComponent, trackWindowScroll };
